/**
 * Logo Component for Stenope Academy
 * 
 * Displays the academy logo with proper handling for different environments.
 */

import React from 'react';
import { Box, Typography } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';

const Logo = ({
    height = '60px',
    showText = true,
    style = {},
    ...props
}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                ...style,
            }}
            {...props}
        >
            <SchoolIcon
                sx={{
                    fontSize: height,
                    color: 'primary.main',
                    filter: 'drop-shadow(0 4px 8px rgba(124, 77, 255, 0.3))',
                }}
            />
            {showText && (
                <Box>
                    <Typography
                        variant="h5"
                        className="neon-text-purple"
                        sx={{
                            fontWeight: 700,
                            letterSpacing: '-0.5px',
                            lineHeight: 1.1,
                        }}
                    >
                        Stenope
                    </Typography>
                    <Typography
                        variant="subtitle2"
                        sx={{
                            color: 'text.secondary',
                            fontWeight: 500,
                            letterSpacing: '2px',
                            textTransform: 'uppercase',
                            fontSize: '0.7rem',
                        }}
                    >
                        Academy
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default Logo;
